module dg.objects {

    function bool(): ng.IDirective {
        return {
            restrict: 'A',
            require: ['ngModel'],
            templateUrl: '/digmo/src/objects/properties/bool/bool.html',
            replace: true,
            compile: (tElement, tAttrs: ILookupAttributes) => {
                var input = angular.element('input', tElement);
                input.attr('ng-model', tAttrs.ngModel);
                return (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ctrls) => {
                    var ngModel = ctrls[0];
                }
            }
        };
    }

    angular.module('dg.objects')
        .directive('bool', bool);
} 